export * from './config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-webstorage/dist/interfaces/index.js
// module id = 82
// module chunks = 0